import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentApiService {
  baseFileApi: string = environment.portalApi;
  httpClient = inject(HttpClient);
  baseApi: string = environment.portalApi;

  constructor() { }
}
